<template>
  <div class="slider-container">
    <div><button @click="prevSlide">Попередній</button></div>
    <div class="product-card" v-for="(product, index) in products" :key="index"
         :style="productStyles[index]">
      <img :src="product.imgSrc" :alt="product.name" class="product-image"/>
      <div class="product-name">{{ product.name }}</div>
    </div>
    <div> <button @click="nextSlide">Наступний</button>
    </div>
  </div>
</template>


<script setup>
import { ref, computed } from 'vue';
import {products} from "@/products-adobe";
import "@/assets/styles/AboutViewStyles.css"

//експорт компонента(product.js)з зовні
const count = ref(0);
defineExpose({
  count
});
const currentSlide = ref(0);
const productStyles = computed(() => {
  return products.value.map((_, index) => {
    let style = {};
    const diff = index - currentSlide.value;

    if (diff === 0) {
      style.transform = `translateX(-50%) scale(1)`;
      style.opacity = 1;
      style.zIndex = 2; // активний слайд
    } else {
      // Віддалені слайди мають менший scale та знижену прозорість
      let scale = 0.3;
      let opacity = 0.1;
      let zIndex = 1;
      let right = diff > 0 ? diff * 30 : (products.value.length + diff) * 30;
      style.transform = `translateX(${right}%) scale(${scale})`;
      style.opacity = opacity;
      style.zIndex = zIndex;
    }
    return style;
  });
});

const nextSlide = () => {
  currentSlide.value = (currentSlide.value + 1) % products.value.length;
};

const prevSlide = () => {
  currentSlide.value = (currentSlide.value - 1 + products.value.length) % products.value.length;
};
</script>

<style scoped>
</style>

